// Persists which left nav bar is active ("main" = Default Nav Bar, "settings" =
// Settings Nav Bar) in a cookie so the choice survives full page loads, refreshes,
// and form saves. The server (_layout.html.haml) reads this cookie to render the
// correct nav bar, decoupling it from the URL. The nav bar therefore changes ONLY
// when the ⚙ Settings button or the × Close button is clicked. See issue #6074.

export const SIDEBAR_MODE_COOKIE = "gl_sidebar_mode"

// One year, in seconds.
const MAX_AGE = 60 * 60 * 24 * 365

// mode: "main" | "settings"
export function persistSidebarMode(mode) {
  document.cookie = `${SIDEBAR_MODE_COOKIE}=${mode}; path=/; max-age=${MAX_AGE}; SameSite=Lax`
}
